// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Accounting from "@wino/accounting/src/Accounting.res.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function makeQuantity(maxStockThreshold, stockRawQuantity, packaging, bulkPrecision, param) {
  let exponent = Stdlib_Option.mapOr(bulkPrecision, 0, prim => prim);
  let defaultQuantity = 1 * 10 ** exponent;
  let defaultQuantity$1 = defaultQuantity | 0;
  let quantity;
  if (maxStockThreshold !== undefined) {
    if (stockRawQuantity !== undefined) {
      if (packaging !== undefined) {
        let quantity$1 = maxStockThreshold - stockRawQuantity | 0;
        let diff = Primitive_int.mod_(quantity$1, packaging);
        quantity = diff !== 0 ? quantity$1 - diff | 0 : quantity$1;
      } else {
        quantity = maxStockThreshold - stockRawQuantity | 0;
      }
    } else {
      quantity = defaultQuantity$1;
    }
  } else {
    quantity = stockRawQuantity !== undefined || packaging === undefined ? defaultQuantity$1 : packaging;
  }
  let match = quantity <= 0;
  if (match) {
    return defaultQuantity$1;
  } else {
    return quantity;
  }
}

function makeProductInput(id, name, description, sku, stockRawQuantityOpt, packagingRawQuantity, taxValue, unitPriceOpt, rawQuantityOpt, bulkPrecision, capacityUnit, param) {
  let stockRawQuantity = stockRawQuantityOpt !== undefined ? stockRawQuantityOpt : 0;
  let unitPrice = unitPriceOpt !== undefined ? unitPriceOpt : 0;
  let rawQuantity = rawQuantityOpt !== undefined ? rawQuantityOpt : 0;
  if (bulkPrecision === undefined) {
    return {
      TAG: "Unit",
      product: {
        id: undefined,
        identifier: id,
        stockKeepingUnit: sku,
        name: name,
        description: description,
        capacityUnit: undefined,
        stock: stockRawQuantity,
        packaging: packagingRawQuantity,
        quantity: rawQuantity,
        expectedQuantity: undefined,
        unitPrice: unitPrice,
        fees: [],
        discounts: [],
        tax: taxValue
      }
    };
  }
  let quantity = Accounting.fromRawProductQuantity(bulkPrecision, rawQuantity).toNumber();
  let stock = Accounting.fromRawProductQuantity(bulkPrecision, stockRawQuantity).toNumber();
  let packaging = Stdlib_Option.map(packagingRawQuantity, value => Accounting.fromRawProductQuantity(bulkPrecision, value).toNumber());
  return {
    TAG: "Bulk",
    product: {
      id: undefined,
      identifier: id,
      stockKeepingUnit: sku,
      name: name,
      description: description,
      capacityUnit: capacityUnit,
      stock: stock,
      packaging: packaging,
      quantity: quantity,
      expectedQuantity: undefined,
      unitPrice: unitPrice,
      fees: [],
      discounts: [],
      tax: taxValue
    },
    precision: bulkPrecision
  };
}

export {
  makeQuantity,
  makeProductInput,
}
/* Accounting Not a pure module */
